///
'use strict';
//
//
if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (prefix) {
        return this.slice(0, prefix.length) === prefix;
    };
}
//
if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}
//
// var host = "http://back.zsfury.com/" 
 var host =  "http://yd.jf61.com/"
// var host =  "http://localhost:60800/"
//
module.exports = function (url) {
    if (url.startsWith('/')) {
        url = url.substring(1);
    }
    return host + url;
}
//
//
$.ajaxSetup({
    beforeSend: function (xhr, settings) {
        xhr.setRequestHeader('token', sessionStorage.getItem('token') || '');
        if (settings.loading !== false) {
            // xhr.$$$layerIndex = layer.load(2, {
            //     shade: 0.03,
            //     time: 700,
            //     container: settings.container,
            //     content: settings.loadingTip || ''
            // })
            return
        }
    },
    complete: function (xhr, responseText) {
        var token = xhr.getResponseHeader('token');
        token && sessionStorage.setItem('token', token);
        // xhr.$$$layerIndex && layer.close(xhr.$$$layerIndex)
        // layer.closeAll('loading');
    }
});
//
require('../css/layer/skin/default/layer.css')



/*****************
 ** WEBPACK FOOTER
 ** ./lib/hostsetter.js
 ** module id = 93
 ** module chunks = 4
 **/